const firebaseConfig = {
  apiKey: 'AIzaSyCmuu_sYgDo3640UP9alHFTRQYswqhy5WQ',
  authDomain: 'owqlo-master-production-id.firebaseapp.com',
  databaseURL: 'https://owqlo-master-production-id.firebaseio.com',
  projectId: 'owqlo-master-production-id',
  storageBucket: 'owqlo-master-production-id.appspot.com',
  messagingSenderId: '737501983455',
  appId: '1:737501983455:web:ebb228383c8ee66e'
}

const sentryConfig = {
  dsn: 'https://27cc1f53241c4ffda7938829b82e6556@sentry.io/1870941',
}

const backendUrl = `https://${process.env.VUE_APP_FUNCTIONS_REGION}-${firebaseConfig.projectId}.cloudfunctions.net/graphql`
const owqloWebsiteUrl = 'https://owqlo.com'

export default {
  firebaseConfig,
  sentryConfig,
  backendUrl,
  owqloWebsiteUrl,
}
